import { render, staticRenderFns } from "./Pago.vue?vue&type=template&id=1906c26e&"
import script from "./Pago.vue?vue&type=script&lang=js&"
export * from "./Pago.vue?vue&type=script&lang=js&"
import style0 from "./Pago.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports